import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../store';
import { LoginForm } from '../components/LoginForm/LoginForm';
import c from '../styles/auth.module.css';

export function LoginPage() {
  const navigate = useNavigate();
  const { user, login } = useAuth();

  useEffect(() => {
    if (user) navigate('/dashboard');
  }, [user, navigate]);

  return (
    <div className={c.page}>
      <LoginForm login={login} />
    </div>
  );
}
